const i18nConfig = {
  en: {
    messages: {},
  },
  sv: {
    messages: require('./sv.json'), // eslint-disable-line
  },
};

export default i18nConfig;
